import styled from '@emotion/styled';

export const StyledStrokeSettingWrap = styled.div`
  margin-top: 18px;
`;

export const StyledSettingArea = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  margin-bottom: 10px;
  padding: 20px 40px;
  & > strong {
    position: relative;
    display: block;
    width: 200px;
    min-width: 200px;
    height: 24px;
    font-size: 16px;
    line-height: 23px;
    color: #333;
  }
`;

export const StyledSettingBox = styled.div`
  position: relative;
  width: calc(100% - 232px);
  margin-left: 20px;
  padding-left: 20px;
  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #e0e0e0;
  }
`;

export const StyledInputList = styled.ul`
  position: relative;

  &.option-mode {
    display: flex;
    flex-direction: column;
  }

  /* &.result-list {
    display: block;
    & li {
      display: block;
      margin-bottom: 20px;
    }
  } */

  & li {
    position: relative;
    display: inline-block;
    margin: 10px 40px 10px 0;
  }

  & .windowing {
    flex-direction: row-reverse;
    padding-left: 10px;
    & input[type='text'] {
      width: 70px;
      margin-left: 10px;
      padding-right: 16px;
    }
    & .inner-label {
      margin-top: 7px;
    }
  }

  & .report_txt {
    width: 760px;
    padding-left: 10px;
    & input[type='text'] {
      padding-right: 62px;
    }
  }
  & .report_txt_help {
    margin-top: 2px;
    padding-left: 10px;
    font-size: 12px;
    color: #555;
  }
`;

export const StyledTransferList = styled.ul`
  & li {
    display: flex;
    align-items: center;
    padding-left: 10px;
    & span {
      font-weight: 400;
      font-size: 14px;
    }
  }
`;

export const StyledDuplicateDescription = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: #bbb;
`;

export const StyledTxtLimited = styled.div`
  position: absolute;
  top: 11px;
  right: 10px;
  font-size: 12px;
`;

export const StyledSmallTxt = styled.span`
  margin: 0 2px;
  padding-left: 10px;
  font-size: 10px;
  color: #999;
`;
